// DEPRECATED: Color constants moved to DaisyUI theme configuration
// See tailwind.config.js for actual semantic colors used in the app
// For consequence type colors, see src/services/discipline/config/eventStyleConfig.js
// These hex values are kept for reference only but are NOT used in styling

// Application routes
export const ROUTES = {
  HOME: '/',
  ROADMAP: '/roadmap',
  JOURNEY: '/journey',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  TEACHER_DASHBOARD: '/teacher-dashboard',
  ADMIN_DASHBOARD: '/admin-dashboard',
  DEV_DASHBOARD: '/developer',
  PROJECT_CONTROL: '/developer/project-control',
  CLASSES: '/classes',
  STUDENTS: '/students',
  PEOPLE: '/people',
  STUDENT_PROFILE: '/studentprofile',
  CLASSLIST: '/classlist',
  SMARTLISTS: '/smartlists',
  SEATING: '/seating',
  QUICK_ISSUE: '/quick-issue',
  DISCIPLINE_RULES: '/discipline-rules',
  DISCIPLINE_QUEUE: '/discipline/queue',
  OFFENCES: '/offences',
  RECORDS: '/records',
  RULES: '/rules',
  SETTINGS: '/settings',
  SCHOOLS: '/schools',
  PROFILE: '/profile',
  ROLE_MANAGEMENT: '/role-management',
  DEV_SETTINGS: '/dev-settings',
  DEV_TEST_ENVIRONMENTS: '/developer/test-environments',
  FIREBASE_USAGE: '/firebase-usage',
  PARENT_LINKING: '/parent-linking',
  ACCESS_CODES: '/access-codes',
  // New parent portal routes
  WELCOME: '/welcome',
  ONBOARDING: '/onboarding',
  PARENT_DASHBOARD: '/parent-dashboard',
  MESSAGES: '/messages',
  MESSAGE_HISTORY: '/sent',
  CONVERSATIONS: '/conversations',
  CLASSROOM_DISPLAY: '/classroom-display',
  CLASS_DISPLAY: '/class-display',
  CLASS_DISPLAY_REMOTE: '/class-display/remote',
  CONSEQUENCE_TYPES: '/consequence-types',
  USERS: '/users',
  SCHOOL_NOTIFICATION_SETTINGS: '/school-notification-settings',
  ANNOUNCEMENTS: '/announcements',
  CAMPAIGNS: '/campaigns',
  SCHOOL_PERIODS: '/school-periods',
  WELCOME_LETTERS: '/welcome-letters',
  ACADEMIC_CALENDAR: '/calendar-periods',
  DATE_RANGES: '/date-ranges',
  TIMETABLE: '/timetable',
  TIMETABLE_BUILDER: '/timetable-builder',
  DAY_BUILDER: '/day-builder',
  CYCLE_BUILDER: '/cycle-builder',
  SUBJECTS: '/subjects',
  TIMETABLE_ASSIGNMENTS: '/timetable-assignments',
  STICKERS: '/stickers',
  AWARDS: '/awards',
  TEACHER_PROFILE: '/teacher',
  SCHOOL_PROFILE: '/school-profile',
  CALENDAR: '/calendar',
  MY_TODOS: '/my-todos',
  MY_TASKS: '/my-tasks',
  ROLES: '/roles',
  TEAMS: '/teams',
  ORG_CHART: '/org-chart',
  WORKFLOW_TEMPLATES: '/workflow-templates',
  WORKFLOWS: '/workflows',
  MY_ID: '/my-id',
  ACCESS_LOG: '/access-log',
  DOMAINS: '/domains',
  GRADES: '/grades',
  ADMIN_TOOLS: '/admin-tools',
  SMART_MESSAGES: '/smart-messages',
  HELP_CENTER: '/help',
  // Media consent — parent signing page + staff compliance roster.
  AGREEMENTS: '/agreements',
  AGREEMENTS_ADMIN: '/agreements-admin',
  // Policies domain — staff/parent library + admin console.
  POLICIES: '/policies',
  POLICIES_ADMIN: '/policies-admin',
  // Consolidated school-setup hub — see src/pages/setup/SetupHubPage.jsx
  SETUP: '/setup',
  // Legacy URL retained as a role-aware redirect. Configuration transfer and
  // synthetic test data live in the Platform Developer workspace.
  SCHOOL_CONFIGURATION: '/setup/configuration',
  // Old per-area paths still resolve (App.jsx redirects them into the hub).
  SETUP_PROFILE: '/setup/profile',
  SETUP_CALENDAR: '/setup/calendar',
  SETUP_ROSTER: '/setup/roster',
  SETUP_TIMETABLE: '/setup/timetable',
  SETUP_ORGANIZATION: '/setup/organization',
  SETUP_COMMUNICATIONS: '/setup/communications',
  SETUP_BEHAVIOUR: '/setup/behaviour',
  // Backward-compatible alias for old links; App redirects this route.
  SETUP_DOMAINS: '/setup/domains',
  // Monetization — pricing + buy flow + post-checkout return pages.
  PRICING: '/pricing',
  BILLING_SUCCESS: '/billing-success',
  BUY_BASIC: '/buy/basic',
  BUY_PRO: '/buy/pro',
  BUY_SUCCESS: '/buy/success',
  BUY_CANCEL: '/buy/cancel',
};

// Firebase collections
export const COLLECTIONS = {
  SCHOOLS: 'schools',
  USERS: 'users',
  CLASSES: 'classes',
  STUDENTS: 'students',
  SEATING_PLANS: 'seatingPlans',
  SMART_LISTS: 'smartLists',
  MENU_ITEMS: 'menuItems',
  DISCIPLINE_QUEUE: 'queue',
  DISCIPLINE_CATEGORIES: 'disciplineCategories',
  SUBJECTS: 'subjects',
  TIMETABLE_ASSIGNMENTS: 'timetableAssignments',
  STICKER_TEMPLATES: 'stickerTemplates',
  AWARD_TEMPLATES: 'awardTemplates',
  AWARD_INSTANCES: 'awardInstances',
  PUBLIC_AWARDS: 'publicAwards',
  STAFF_PROFILES: 'staffProfiles',
  FAMILY_CARDS: 'familyCards',
  BROADCAST_LOGS: 'broadcastLogs',
  GRADES: 'grades',
  ACCESS_PASSES: 'accessPasses',
  ACCESS_LOGS: 'accessLogs',
};

// Common validation rules
export const VALIDATION = {
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD_MIN_LENGTH: 6,
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 50
};

// UI constants
export const UI = {
  SIDEBAR_WIDTH: '250px',
  HEADER_HEIGHT: '64px',
  MOBILE_BREAKPOINT: '768px',
  ANIMATION_DURATION: '0.3s'
};

// Grid/Seating constants
export const GRID = {
  DEFAULT_ROWS: 6,
  DEFAULT_COLS: 8,
  MAX_ROWS: 20,
  MAX_COLS: 20,
  MIN_ROWS: 2,
  MIN_COLS: 2
};

// Student status options
export const STUDENT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  GRADUATED: 'graduated',
  TRANSFERRED: 'transferred',
  WITHDRAWN: 'withdrawn'
};

// Class types
export const CLASS_TYPES = {
  REGULAR: 'regular',
  HONORS: 'honors',
  AP: 'ap',
  SPECIAL: 'special',
  ELECTIVE: 'elective',
};

// CSS utility classes
export const CSS_CLASSES = {
  CARD_BASE: 'p-6 bg-base-100 rounded-2xl shadow-lg',
  CARD_ELEVATED: 'p-4 bg-base-100 rounded-xl shadow-md border border-base-300',
  BUTTON_BASE: 'btn',
  BUTTON_BASE_WITH_SHADOW: 'btn shadow-sm',
  INPUT_BASE: 'input input-bordered',
  TEXTAREA_BASE: 'textarea textarea-bordered'
};

// Menu configuration
export const MENU_ROLES = {
  TEACHER: 'teacher',
  ADMIN: 'admin',
  PARENT: 'parent',
  DEV: 'dev'
};

export const DEFAULT_MENU_ITEMS = [
  {
    id: 'teacher-dashboard',
    label: 'Teacher Dashboard',
    icon: 'ChartBarIcon',
    href: '/teacher-dashboard',
    roles: { teacher: true, admin: false, parent: false, dev: false },
    showInMenu: true,  // Appears in sidebar navigation
    order: 1,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'admin-dashboard',
    label: 'Admin Dashboard',
    icon: 'ChartBarIcon',
    href: '/admin-dashboard',
    roles: { teacher: false, admin: true, parent: false, dev: false },
    showInMenu: true,
    order: 1,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'dev-dashboard',
    label: 'Dev Dashboard',
    icon: 'ChartBarIcon',
    href: '/developer',
    roles: { teacher: false, admin: false, parent: false, dev: true },
    showInMenu: true,
    order: 1,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'classes',
    label: 'Classes',
    icon: 'BuildingOfficeIcon',
    href: '/classes',
    roles: { teacher: true, admin: true, parent: false, dev: true },
    showInMenu: true,
    order: 2,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'students',
    label: 'Students',
    icon: 'UserGroupIcon',
    href: '/students',
    roles: { teacher: true, admin: true, parent: false, dev: true },
    showInMenu: true,
    order: 3,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    // Phase 1 — top-level People page (directory + groups atlas).
    // /students, /teams, /roles redirect into this page.
    id: 'people',
    label: 'People',
    icon: 'UserGroupIcon',
    href: '/people',
    roles: { teacher: true, admin: true, parent: false, dev: true },
    showInMenu: true,
    order: 3.5,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'classlist',
    label: 'ClassList Pro',
    icon: 'ClipboardDocumentListIcon',
    href: '/classlist',
    roles: { teacher: true, admin: true, parent: false, dev: true },
    showInMenu: true,
    order: 4,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'smartlists',
    label: 'Smart Lists',
    icon: 'BoltIcon',
    href: '/smartlists',
    roles: { teacher: true, admin: true, parent: false, dev: true },
    showInMenu: true,
    order: 5,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'seating',
    label: 'Seating Plans',
    icon: 'Squares2X2Icon',
    href: '/seating',
    roles: { teacher: true, admin: true, parent: false, dev: true },
    showInMenu: true,
    order: 6,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'quickissue',
    label: 'Quick Issue',
    icon: 'ExclamationTriangleIcon',
    href: '/quick-issue',
    roles: { teacher: true, admin: true, parent: false, dev: true },
    showInMenu: true,
    order: 7,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'discipline-dashboard',
    label: 'Discipline Dashboard',
    icon: 'ChartBarSquareIcon',
    href: '/discipline-dashboard',
    roles: { teacher: true, admin: true, parent: false, dev: true },
    showInMenu: true,
    order: 8,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'discipline-queue',
    label: 'Discipline Queue',
    icon: 'QueueListIcon',
    href: '/discipline/queue',
    roles: { teacher: true, admin: true, parent: false, dev: true },
    showInMenu: true,
    order: 9,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'users',
    label: 'Users',
    icon: 'UsersIcon',
    href: '/users',
    roles: { teacher: false, admin: true, parent: false, dev: true },
    showInMenu: true,
    order: 10,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'setup',
    label: 'Setup',
    icon: 'Cog6ToothIcon',
    href: '/setup',
    roles: { teacher: false, admin: true, parent: false, dev: true },
    showInMenu: true,
    order: 10.2,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'organization',
    label: 'Organization',
    icon: 'BuildingOffice2Icon',
    href: '#',
    roles: { teacher: false, admin: true, parent: false, dev: true },
    showInMenu: false,
    order: 10.3,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'roles',
    label: 'Roles',
    icon: 'BriefcaseIcon',
    href: '/roles',
    roles: { teacher: false, admin: true, parent: false, dev: true },
    showInMenu: false,
    order: 1,
    visible: true,
    parentId: 'organization',
    depth: 1
  },
  {
    id: 'teams',
    label: 'Teams',
    icon: 'UsersIcon',
    href: '/teams',
    roles: { teacher: false, admin: true, parent: false, dev: true },
    showInMenu: false,
    order: 2,
    visible: true,
    parentId: 'organization',
    depth: 1
  },
  {
    id: 'org-chart',
    label: 'Org Chart',
    icon: 'ShareIcon',
    href: '/org-chart',
    roles: { teacher: false, admin: true, parent: false, dev: true },
    showInMenu: false,
    order: 3,
    visible: true,
    parentId: 'organization',
    depth: 1
  },
  {
    id: 'my-todos',
    label: 'My Todos',
    icon: 'CheckCircleIcon',
    href: '/my-todos',
    roles: { teacher: true, admin: true, parent: false, dev: true },
    showInMenu: true,
    order: 10.35,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'my-tasks',
    label: 'My Tasks',
    icon: 'ClipboardDocumentCheckIcon',
    href: '/my-tasks',
    roles: { teacher: true, admin: true, parent: true, dev: true },
    showInMenu: true,
    order: 10.36,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'welcome-letters',
    label: 'Welcome Letters',
    icon: 'DocumentTextIcon',
    href: '/welcome-letters',
    roles: { teacher: true, admin: true, parent: false, dev: true },
    showInMenu: false,
    order: 10.7,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'subjects',
    label: 'Subjects',
    icon: 'BookOpenIcon',
    href: '/subjects',
    roles: { teacher: false, admin: true, parent: false, dev: true },
    showInMenu: false,
    order: 10.75,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'grades',
    label: 'Grades',
    icon: 'AcademicCapIcon',
    href: '/grades',
    roles: { teacher: false, admin: true, parent: false, dev: true },
    showInMenu: false,
    order: 30,
    visible: true,
    parentId: 'school_1757962663554',
    depth: 1
  },
  {
    id: 'timetable-builder',
    label: 'Timetable Builder',
    icon: 'CalendarDaysIcon',
    href: '/timetable-builder',
    roles: { teacher: true, admin: true, parent: false, dev: true },
    showInMenu: false,
    order: 10.8,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'timetable-assignments',
    label: 'Assign Timetable',
    icon: 'TableCellsIcon',
    href: '/timetable-assignments',
    roles: { teacher: false, admin: true, parent: false, dev: true },
    showInMenu: true,
    order: 10.85,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'stickers',
    label: 'Stickers',
    icon: 'SparklesIcon',
    href: '/domains?domain=recognition&step=action',
    roles: { teacher: true, admin: true, parent: false, dev: true },
    showInMenu: false,
    order: 10.9,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'awards',
    label: 'Awards',
    icon: 'TrophyIcon',
    href: '/domains?domain=recognition&step=action',
    roles: { teacher: true, admin: true, parent: false, dev: true },
    showInMenu: false,
    order: 10.95,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: 'Cog6ToothIcon',
    href: '/settings',
    roles: { teacher: true, admin: true, parent: true, dev: true },
    showInMenu: true,
    order: 11,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'smart-messages',
    label: 'Smart Messages',
    icon: 'ChatBubbleLeftRightIcon',
    href: '/smart-messages',
    roles: { teacher: true, admin: true, parent: false, dev: true },
    showInMenu: true,
    order: 10.5,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'messaging-preferences',
    label: 'Messaging',
    icon: 'ChatBubbleLeftRightIcon',
    href: '/messaging-preferences',
    roles: { teacher: true, admin: true, parent: true, dev: true },
    order: 11,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'messaging-test',
    label: 'Test Messages',
    icon: 'BeakerIcon',
    href: '/messaging-test',
    roles: { teacher: false, admin: true, parent: false, dev: true },
    order: 12,
    visible: true,
    parentId: null,
    depth: 0
  },
  {
    id: 'unified-dashboard',
    label: 'All Features',
    icon: 'SparklesIcon',
    href: '/unified',
    roles: { teacher: true, admin: true, parent: true, dev: true },
    order: 1,
    visible: true,
    parentId: null,
    depth: 0
  }
];

// Menu item creation defaults
export const MENU_ITEM_DEFAULTS = {
  icon: 'ChartBarIcon',
  roles: { teacher: true, admin: true, parent: false, dev: true },
  showInMenu: true,  // New items visible in sidebar by default
  visible: true,
  inDevelopment: false,  // Flag to indicate features under development
  parentId: null,
  depth: 0,
  order: 1
};

// Discipline system constants - Legacy options not yet migrated to disciplineConfigService
// NOTE: Most discipline configuration has been moved to src/services/disciplineConfigService.js
export const DISCIPLINE = {
  // These remain here temporarily for backwards compatibility
  HISTORY_OPTIONS: [
    { value: null, label: 'All students' },
    { value: 'first-offense', label: 'First offense only' },
    { value: '2-plus', label: '2+ offenses' },
    { value: '5-plus', label: '5+ offenses' }
  ],

  COUNT_TYPE_OPTIONS: [
    { value: 'mentions', label: 'mentions', singular: 'mention' },
    { value: 'demerits', label: 'demerits', singular: 'demerit' },
    { value: 'detentions', label: 'detentions', singular: 'detention' }
  ],

  // MIGRATED TO disciplineConfigService:
  // - SEVERITY_LEVELS
  // - GRADE_OPTIONS
  // - TIMEFRAME_OPTIONS
  // - CONSEQUENCE_TYPE_OPTIONS
  // - QUEUE_STATUS
  // - RULE_TYPES
};
